import { connect } from 'react-redux'
import { selectLabelsById } from 'selectors/labels'

class LabelView extends React.PureComponent {
  render() {
    const { color, name } = this.props
    return (
      <span
        className="label"
        style={{
          color,
          backgroundColor: `${color}26`,
        }}
      >
        {name}
      </span>
    )
  }
}

const Label = connect((initialState, initialOwnProps) => {
  const labelId = initialOwnProps.labelId
  return state => {
    const labelsById = selectLabelsById(state)
    const found = labelsById[labelId]
    if (!found) return {}
    return {
      color: found.color,
      name: found.name,
    }
  }
})(LabelView)

export default Label
